import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Injectable()
export class FileDownloadService {

    sass_token: string;
    constructor(private http: HttpClient,
        public snackBar: MatSnackBar) {
            this.sass_token = environment.saas_token
         }

    download(fileUrl: string) {
        this.http.get<string>(fileUrl + this.sass_token, { responseType: 'blob' as 'json' })
            .subscribe(data => {
                let fileName = fileUrl.substr(fileUrl.lastIndexOf('/') + 1).split('/')[0];
                const nav = (window.navigator as any);
                let fileData = [data];
                let blobObject = new Blob(fileData);
                if (nav.msSaveOrOpenBlob) {
                    nav.msSaveOrOpenBlob(blobObject, fileName);
                } else {
                    let a = document.createElement('a');
                    let url = window.URL.createObjectURL(blobObject);
                    a.href = url;
                    a.download = fileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            }, error => {
                this.snackBar.open(`File Name : ${fileUrl.substr(fileUrl.lastIndexOf('/') + 1).split('/')[0]} Error : ${error.statusText}`, 'Dismiss', { duration: 1000 });
            })
    }
}